import React, { useEffect } from "react";
import "../pages/DashboardPages/NeedPages/searchResults.css";

const PaginationFile = ({
  totalRecords,
  usersPerPage,
  currentRecordsPerPage,
  setCurrentRecordsPerPage,
}) => {
  const totalPages = Math.ceil(totalRecords / usersPerPage);
  const [jumpValue, setJumpValue] = React.useState("");

  // Add useEffect to handle scroll after page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentRecordsPerPage]);

  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentRecordsPerPage <= 2) {
      return [1, 2, 3, "..."];
    } else if (currentRecordsPerPage >= totalPages - 1) {
      return ["...", totalPages - 2, totalPages - 1, totalPages];
    } else {
      return [
        "...",
        currentRecordsPerPage - 1,
        currentRecordsPerPage,
        currentRecordsPerPage + 1,
        "...",
      ];
    }
  };

  const changePage = (newPage) => {
    if (
      newPage >= 1 &&
      newPage <= totalPages &&
      newPage !== currentRecordsPerPage
    ) {
      setCurrentRecordsPerPage(newPage);
    }
  };

  const handleJump = () => {
    if (!jumpValue) return;

    const pageNumber = parseInt(jumpValue, 10);
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      changePage(pageNumber);
      setJumpValue(""); // clear input after jump
    }
  };

  return (
    <div className="search-pagination-wrapper my-3">
      <button
        className="search-pagination-btn search-first-btn"
        disabled={currentRecordsPerPage === 1}
        onClick={() => changePage(1)}
      >
        «
      </button>

      <div className="search-page-numbers">
        {getPageNumbers().map((pageNum, index) => (
          <button
            key={index}
            className={`search-page-number ${
              currentRecordsPerPage === pageNum ? "search-page-active" : ""
            } ${pageNum === "..." ? "search-ellipsis" : ""}`}
            onClick={() => typeof pageNum === "number" && changePage(pageNum)}
            disabled={pageNum === "..."}
          >
            {pageNum}
          </button>
        ))}
      </div>

      <button
        className="search-pagination-btn search-last-btn"
        disabled={currentRecordsPerPage === totalPages}
        onClick={() => changePage(totalPages)}
      >
        »
      </button>

      {/* Jump to page */}
      <div className="jump-container">
        <input
          type="number"
          min="1"
          max={totalPages}
          value={jumpValue}
          onChange={(e) => setJumpValue(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleJump()}
          placeholder="Go to page"
          className="jump-input"
        />
        <button
          className="search-pagination-btn search-last-btn"
          onClick={handleJump}
          disabled={!jumpValue || jumpValue < 1 || jumpValue > totalPages}
        >
          Go
        </button>
      </div>
    </div>
  );
};

export default PaginationFile;
